import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { TablepagedComponent } from './app/components/containers/table/tablepaged/tablepaged.component';


bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
